/**
 * generalOutline.ts
 * [Readme] --------------------------------------------------------------------------------------
 * 
 * 개요 탭에서 사용하는 데이터의 모음입니다.
 * 일부 데이터는 직접 개요 페이지 컴포넌트에 넣는 경우도 존재합니다.
 * 
 * -----------------------------------------------------------------------------------------------
 */

import img1 from 'assets/Desktop/images/parcelOut/summary_planimages_63a.png';
import img2 from 'assets/Desktop/images/parcelOut/summary_planimages_63b.png';
import img3 from 'assets/Desktop/images/parcelOut/summary_planimages_84a.png';
import img4 from 'assets/Desktop/images/parcelOut/summary_planimages_84b.png';

import bgPremium1 from 'assets/Desktop/images/parcelOut/premium_01.jpg';
import bgPremium2 from 'assets/Desktop/images/parcelOut/premium_02.jpg';
import bgPremium3 from 'assets/Desktop/images/parcelOut/premium_03.jpg';
import bgPremium4 from 'assets/Desktop/images/parcelOut/premium_04.jpg';

import bgPremiumMo1 from 'assets/Mobile/images/ParcelOut/premium_m_01.jpg';
import bgPremiumMo2 from 'assets/Mobile/images/ParcelOut/premium_m_02.jpg';
import bgPremiumMo3 from 'assets/Mobile/images/ParcelOut/premium_m_03.jpg';
import bgPremiumMo4 from 'assets/Mobile/images/ParcelOut/premium_m_04.jpg';


/**
 * 개요 탭의 분양일정 메뉴에 사용되는 데이터입니다.
 */
export const dataCalender = [
  { date: '2023.03.31', detail: '주택전시관 오픈' },
  { date: '04.10', detail : '특별공급 청약'},
  { date: '04.11', detail : '1순위 청약'},
  { date: '04.12', detail : '2순위 청약'},
  { date: '04.18', detail : '당첨자 발표'},
  { date: '05.02~05.04', detail : '정당계약'}
];

/**
 * @데스크탑프리미엄deprecated
 * 개요의 프리미엄 메뉴에 사용되는 데이터입니다.
 */
export const dataPremium = [
  {
    img: bgPremium1,
    subtit: 'PREMIUM 1',
    tit: '모두가 동경하는 \n교육 1번지',
    detail:'도보 통학이 가능한 초.중교를 비롯해\n남고/여고/조선대 인접\n\n다양한 학원들이 밀집합\n광주 최대 학원가 인접\n\n남구문화정보도서관/남구청소년도서관 등\n공공도서관 이용 가능'
  },
  {
    img: bgPremium2,
    subtit: 'PREMIUM 2',
    tit: '삶의 질을 높여줄\n생활 인프라',
    detail:'하나로마트/봉선시장/이마트 인접\n\n반경2km에 푸른길공원/봉선공원/\n광주사직공원/월산근린공원 등 위치\n\n구청 및 관공서/금융/의료 등\n편리한 생활 인프라'
  },
  {
    img: bgPremium3,
    subtit: 'PREMIUM 3',
    tit: 'e편한세상이 선보이는\n특별한 주거 상품',
    detail:'광주 최초 C2 HOUSE 특화 설계 적용\n\n실내 골프연습장, 스크린 골프룸,  피트니스센터,\n라운지 카페 등 입주민의 품격을\n높이는 고급 커뮤니티 시설\n\n유아놀이터가 있는 어린이집과 독서실,\n스터디 카페를 갖춘 자녀들을 위한 다양한 공간 적용'
  },
  {
    img: bgPremium4,
    subtit: 'PREMIUM 4',
    tit: '개발호재 가득한\n미래 프리미엄',
    detail:'도보 10분 거리에 광주도시철도\n2호선 백운광장역 2026년 개통 예정\n<출처 : 광주광역시남구 공고 제2020 – 901호(2020. 7 .8)>\n\n백운고가 철거 후 백운광장과 푸른길공원을\n연결해 정원으로 조성하는\n‘백운광장 푸른길 브릿지 조성사업‘\n2023년 12월 준공예정\n<출처 : 광주광역시 남구 홈페이지>'
  }
];

/**
 * @모바일프리미엄
 * 개요의 프리미엄 메뉴에 사용되는 데이터입니다.
 */
 export const moPremium = [
  {
    moImg: bgPremiumMo1,
    subtit: 'PREMIUM 1',
    tit: '모두가 동경하는 교육 1번지',
    detail:'도보 통학이 가능한 초.중교를 비롯해 남고/여고/조선대 인접 다양한 학원들이 밀집합 광주 최대 학원가 인접 남구문화정보도서관/남구청소년도서관 등 공공도서관 이용 가능'
  },
  {
    moImg: bgPremiumMo2,
    subtit: 'PREMIUM 2',
    tit: '삶의 질을 높여줄 생활 인프라',
    detail:'하나로마트/봉선시장/이마트 인접 반경2km에 푸른길공원/봉선공원/광주사직공원/월산근린공원 등 위치 구청 및 관공서/금융/의료 등 편리한 생활 인프라'
  },
  {
    moImg: bgPremiumMo3,
    subtit: 'PREMIUM 3',
    tit: 'e편한세상이 선보이는 특별한 주거 상품',
    detail:'광주 최초 C2 HOUSE 특화 설계 적용 실내 골프연습장, 스크린 골프룸,  피트니스센터, 라운지 카페 등 입주민의 품격을 높이는 고급 커뮤니티 시설 유아놀이터가 있는 어린이집과 독서실, 스터디 카페를 갖춘 자녀들을 위한 다양한 공간 적용'
  },
  {
    moImg: bgPremiumMo4,
    subtit: 'PREMIUM 4',
    tit: '개발호재 가득한 미래 프리미엄',
    detail:'도보 10분 거리에 광주도시철도 2호선 백운광장역 2026년 개통 예정 <출처 : 광주광역시남구 공고 제2020 – 901호(2020. 7 .8)> 백운고가 철거 후 백운광장과 푸른길공원을 연결해 정원으로 조성하는 ‘백운광장 푸른길 브릿지 조성사업‘ 2023년 12월 준공예정 <출처 : 광주광역시 남구 홈페이지>'
  }
];

/**
 * 평방미터를 평형으로 계산하기 위한 기본 고정 값입니다.
 * 평방미터 * CAL_FEET 하여 처리하며 Math.floor(평방미터(공급면적) * CAL_FEET)를 하여 소수점을 없앱니다.
 */
const CAL_FEET: number = 0.3025;

/**
 * 개요의 세대정보 메뉴에 사용되는 데이터입니다.
 */
export const dataSlide = [
  {
    img: img1,
    title: '63㎡A형',
    titleSwitchActive: `${Math.floor(83.1770 * CAL_FEET)}평A형`,
    subTitle: '98세대',
    subTitle02: '98',
    total: '123세대(일반분양 98세대)',
    detail: '실별 짜임새 있는 공간 구성과 맞통풍 설계로 환기와 채광이 우수한 판상형 구조'
  },
  {
    img: img2,
    title: '63㎡B형',
    titleSwitchActive: `${Math.floor(83.4923 * CAL_FEET)}평B형`,
    subTitle: '14세대',
    subTitle02: '22',
    total: '14세대(일반분양 14세대)',
    detail: '공간별 프라이버시가 확보되는 평면으로 열린 거실과 오픈형 주방을 갖춘 탑상형 구조'
  },
  {
    img: img3,
    title: '84㎡A형',
    titleSwitchActive: `${Math.floor(110.2444 * CAL_FEET)}평A형`,
    subTitle: '38세대',
    subTitle02: '38',
    total: '278세대(일반분양 38세대)',
    detail: '우수한 개방감과 여유로운 공간구성, 주방 원스톱 세탁실 등을 갖춰\n 생활의 편리함을 극대화한 판상형 구조'
  },
  {
    img: img4,
    title: '84㎡B형',
    titleSwitchActive: `${Math.floor(110.0136 * CAL_FEET)}평B형`,
    subTitle: '26세대',
    subTitle02: '26',
    total: '127세대(일반분양 26세대)',
    detail:
      '부부공간과 자녀공간을 분리하여 공간별 프라이버시가 확보되고,\n 열린 거실과 오픈형 주방을 갖춘 탑상형 구조'
  }
];

/**
 * 개요의 세대정보 메뉴에서 계를 나타내는데 사용되는 데이터입니다.
 */
export const dataSlideResult = {
  title: '계',
  subTitle: '542세대',
  subTitle02: '169',
  total: '207'
};
